import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";

import { IgTableWrapper } from "@intelligems/ig-theme";
import { StripeApiProductFeatureDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ValueColumn } from "@src/features/admin/pages/overview/components/Tables/ProductFeatureTable/renderers/ValueColumn";
import { theme } from "@src/theme";

interface ProductFeaturesTableProps {
  features: StripeApiProductFeatureDto[];
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const ProductFeaturesTable = ({
  features,
}: ProductFeaturesTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<StripeApiProductFeatureDto & { "": "" }>[] = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        cellStyle: { justifyContent: "start" },
        valueGetter: (params) => {
          return params.data?.name.split(" -")[0];
        },
      },
      {
        headerName: "Value",
        field: "",
        sortable: true,
        cellRenderer: ValueColumn,
        valueGetter: (params) => {
          return params.data?.metadata.value;
        },
      },
    ],
    []
  );

  return (
    <Grid container>
      <Grid
        item
        sx={{
          width: "100%",
          maxHeight: "500px",
        }}
      >
        <IgTableWrapper height={"50vh"}>
          <AgGridReact<StripeApiProductFeatureDto>
            theme={myTheme}
            rowData={features}
            defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            headerHeight={25}
            suppressCellFocus={true}
          />
        </IgTableWrapper>
      </Grid>
    </Grid>
  );
};
